import { Category } from '../../../../../shared/issuesV2';
import type {
  IssueByCategory,
  LicensingIssue,
  QualityIssue,
  VulnIssue,
} from '../../../../../shared/issuesV2';

import LicenseIssueItem from './LicenseIssueItem';
import QualityIssueItem from './QualityIssueItem';
import VulnerabilityIssueItem from './VulnerabilityIssueItem';

import './IssueItem.less';

type IssueItemProps = {
  //  Allows us to render the correct IssueItem component.
  category: Category;
  //  Issue data.
  issue: IssueByCategory<Category>;
};

/**
 * IssueItem represents a single "item" in the IssuesInbox.
 */
const IssueItem = ({ category, issue }: IssueItemProps) => {
  switch (category) {
    case Category.Licensing:
      return <LicenseIssueItem issue={issue as LicensingIssue} />;
    case Category.Vulnerability:
      return <VulnerabilityIssueItem issue={issue as VulnIssue} />;
    case Category.Quality:
      return <QualityIssueItem issue={issue as QualityIssue} />;
    default:
      return null;
  }
};

export default IssueItem;
